import * as React from "react";
import SectionComponent from "components/common/Section/SectionComponent";
import ReadOnlyFormGroup from "components/common/ReadOnlyFormGroup";
import Routes from "routing/Routes";
import { Link } from "components/common";
import AppConfig from "util/AppConfig";
const _getSourceType = (authServiceId, type = "unknown") => {
  if (type === "SYNCED" && authServiceId) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, type.toLowerCase(), " with", " ", /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.show(authServiceId) }, "authentication service"));
  }
  return type.toLowerCase();
};
const isCloud = AppConfig.isCloud();
const ProfileSection = ({ team: { authServiceId, description, name, type } }) => {
  const sourceType = _getSourceType(authServiceId, type);
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Profile" }, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Name", value: name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Description", value: description }), !isCloud && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Source", value: sourceType }));
};
export default ProfileSection;
